import { HttpClient } from '@angular/common/http';

import { environment } from '../../../environments/environment';

export class BaseService {
  public apiUrl = environment.apiUrl;

  constructor(public http: HttpClient) {}

  protected httpGet<T>(url: string, params: any = null) {
    const paramsValue = params
      ? `?${Object.keys(params)
          .filter((p) => params[p])
          .map((p) => `${p}=${params[p]}`)
          .join('&')}`
      : '';
    return this.http.get<T>(`${this.apiUrl}${url}${paramsValue}`);
  }
}
